export default {
  createdAt: 1727964001,
  updatedAt: 1727964001,
  slug: 'templates',
  title: 'Templates - Free Dashboard & Chart Examples',
  description: 'Create beautiful dashboards and calculators in seconds. Customize then publish to any web platform.',
  images: {
    resourceUrl: '/img/pages/templates/featured-image.webp',
    resourceUrlAlt: 'Three phones containing different template examples',
    openGraph: '/img/pages/templates/og-image.webp'
  },
  reviews: []
};